<template style="height: 100%;">
  <div class="ExmCon">
    <el-dialog
      :title="$t('original.languages178')"
      :visible.sync="dialogTableVisible"
      width="38%"
    >
      <div style="margin: 10px;">
        <table style="border-radius: 18px;width: 100%;">
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages185') }} ：</td>
            <td class="td_right">{{ Information.RealName }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.phone') }}：</td>
            <td class="td_right">{{ Information.Phone }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages207') }}：</td>
            <td class="td_right">{{ Information.visitorName }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages208') }}：</td>

            <td class="td_right">{{ Information.ConsultTheme }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages209') }}：</td>
            <td class="td_right">{{ Information.ConsultCntIntroduce }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages210') }}：</td>
            <td class="td_right">{{ Information.ConsultationTime }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages211') }}：</td>
            <td class="td_right">{{ Information.ConAddressName }}</td>
          </tr>
          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages212') }}：</td>
            <td class="td_right">{{ Information.ConsultType }}</td>
          </tr>

          <tr style="height: 40px;">
            <td class="td_left">删除排班：</td>
            <td class="td_right">
              <el-radio v-model="CancelSchedul" label="1">是</el-radio>
              <el-radio v-model="CancelSchedul" label="0">否</el-radio>
            </td>
             
          </tr>


          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages213') }}：</td>
            <td class="td_right"><el-input v-model="Information.CancelCause" placeholder="请输入内容"></el-input></td>
          </tr>
        </table>

        <table style="margin-top=20px; width:100%">
          <tr style="height: 30px;">
            <td class="td_left">
             {{ $t('original.languages214') }}
            </td>
            <td
              class="td_right"
              :style="
                Information.CancelApproval == 1
                  ? 'color: rgba(0, 136, 255, 1);'
                  : Information.CancelApproval == 3
                  ? 'color: rgba(242, 75, 78, 1);'
                  : Information.CancelApproval == 2
                  ? 'color: rgba(21, 191, 109, 1); '
                  : 'color: rgba(141, 141, 141, 1);'
              "
            >
              {{
                Information.CancelApproval == 1
                  ? '待审批'
                  : Information.CancelApproval == 3
                  ? '已拒绝'
                  : Information.CancelApproval == 2
                  ? '已同意'
                  : '已撤销'
              }}

            </td>
          </tr>
          <tr style="height: 30px;" v-if="Information.CancelApproval == 3 && Information.Isshow">
            <td class="td_left">拒绝原因</td>
            <td class="td_right">{{ Information.CancelPostil }}</td>
          </tr>
          <!-- CancelPostil -->
          <tr style="height: 30px;"
            v-if="
              (Information.CancelApproval == 3 ||
                Information.CancelApproval == 2) &&
              Information.Isshow
            "
          >
            <td class="td_left">{{ $t('original.languages192') }}</td>
            <td class="td_right">{{ Information.AuditName }}</td>
          </tr>

          <tr style="height: 30px;"
            v-if="
              (Information.CancelApproval == 3 ||
                Information.CancelApproval == 2) &&
              Information.Isshow
            "
          >
            <td class="td_left">取消时间</td>
            <td class="td_right">{{ Information.CancelTime }}</td>
          </tr>

          <tr style="height: 30px;" v-if="Information.CancelApproval == 1">
            <td class="td_left"> 拒绝原因</td>
            <td class="td_right">
              <el-input
                placeholder="拒绝原因"
                type="textarea"
                v-model="Information.CancelPostil"
              ></el-input>
            </td>
          </tr>
        </table>

        <div  class="buttons"  style="width: 100%;"  v-if="Information.CancelApproval == 1">
          <el-button style="margin-top: 20px;margin-left: 40%;" :loading="UpdateStatusload"  type="primary"  @click="UpdateStatus(
          (Information.CancelApproval = 3),
          Information.AppointmentID,)">
             {{ $t('original.languages195') }}
          </el-button>

          <el-button type="primary" :loading="UpdateStatusload" @click="UpdateStatus((Information.CancelApproval = 2),Information.AppointmentID,)">
            {{ $t('original.languages196') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>


        <el-button :disabled='spcinu' type="primary" @click="batchfun('1','1')">选中同意</el-button>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('-1','1')">选中拒绝</el-button>
        <el-button :disabled='spcinu' type="success" @click="batchfun('1','2')">全部同意</el-button>
        <el-button :disabled='spcinu' type="danger"  @click="batchfun('-1','2')">全部拒绝</el-button>



        <el-table :data="UndoTableData" style="margin-top:15px" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')" @selection-change="handleSelectionChange">

           <el-table-column type="selection" width="55"></el-table-column>

           
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
           
          <el-table-column prop="visitorName" :label="$t('original.languages207')"></el-table-column>

          <el-table-column prop="ConsultationTime" :label="$t('original.languages170')"></el-table-column>

          <el-table-column  prop="CancelCause" :label="$t('original.languages216')"></el-table-column>

          <el-table-column prop="RealName" :label="$t('original.languages185')"></el-table-column>
          <el-table-column
            prop="AppointmentTime"
            :label="$t('original.languages217')"
          ></el-table-column>

          <el-table-column :label="$t('original.languages190')" width="100" >
            <template>
              <span class="state-blue" style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">
               {{ $t('original.languages200') }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span
                class="option-blue copy_Button"
                @click="handleCheck(scope.row)
                Information.Isshow = false">
                {{ $t('original.languages201') }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: 20px; text-align: right;"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="UndoCount"
        ></el-pagination>
        
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages202')">
        <el-table :data="DoTableData" v-loading="IsDataLoad"
          :element-loading-text="$t('original.languages22')"
        >
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="visitorName" :label="$t('original.languages207')"></el-table-column>

          <el-table-column prop="ConsultationTime"  :label="$t('original.languages170')"></el-table-column>

          <el-table-column
            prop="CancelCause"
            :label="$t('original.languages216')"
          ></el-table-column>
  
          <el-table-column prop="CancelUser" :label="$t('original.languages185')"></el-table-column>

          <el-table-column
            prop="AppointmentTime"
            :label="$t('original.languages217')"
          ></el-table-column>

          <el-table-column :label="$t('original.languages190')" width="100">
            <template slot-scope="scope">
              <span style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;" class="state-green" v-if="scope.row.CancelApproval == 2">
                {{ $t('original.languages203') }}
              </span>
              <span class="state-red" v-else-if="scope.row.CancelApproval == 3" style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">
                已拒绝
              </span>
              <span class="state-gray" v-else>
                已撤销
              </span>
            </template>



          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span
                class="option-blue copy_Button"
                @click="handleCheck(scope.row)
                Information.Isshow = true">
                 {{ $t('original.languages174') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px; text-align: right;"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="DoCount"
          v-if="DoCount > 0"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      spcinu:false,
      CancelSchedul:'1',
      CancelCause:'',
      IsDataLoad: true,
      dialogTableVisible: false, //打开详情框
      pageSize: 10,
      pageIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      Information: {
        AppointmentID: '',
        visitorName: '',
        ConsultationTime: '',
        CancelCause: '',
        RealName: '',
        AppointmentTime: '',
        Phone: '',
        ConsultTheme: '',
        ConsultCntIntroduce: '',
        ConAddressName: '',
        ConsultType: '',
        CancelApproval: '',
        CancelPostil: '',
        CancelTime: '',
        CancelUser: '',
        Isshow: false,
        AuditName: '',
      },
      UpdateStatusload:false,
      DeleteKeys: [],
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    batchfun(val,type){
      if(type == 1){
        this.spcinu = true;
        if(this.DeleteKeys.length > 0){
          this.$Http_Post('management/consultsubscribe/batchhandlecancelappointment', {handleFlag: val,ids:this.DeleteKeys}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.spcinu = false;
              this.Global.request_successful(res.Message);
              window.location.reload();
            } else {
              this.spcinu = false;
              this.$message.error(res.Message);
            }
          })
        }else{
          alert('请选择选项！');
        }
      }else if(type == 2){//全部
        this.spcinu = true;
        this.$Http_Post('management/consultsubscribe/batchhandlecancelappointment', {handleFlag: val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.spcinu = false;
            this.Global.request_successful(res.Message);
            window.location.reload();
          } else {
            this.spcinu = false;
            this.$message.error(res.Message);
          }
        })
      }
    },
    // 全选
    handleSelectionChange(e){
      this.DeleteKeys = [];
      for(let item of e){
        this.DeleteKeys.push(item.AppointmentID);
      }
    },
    GetData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post('ConsultSubscribe/GetAllExamineAppointment', {pageSize: this.pageSize,pageIndex: this.pageIndex}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          // _this.$parent.RefreshAppointmentCount(_this.UndoCount);
        }
      })
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetData();
    },
    handleCheck(obj) {
      let _this = this;
      _this.dialogTableVisible = true;
      _this.Information.AppointmentID = obj.AppointmentID;
      _this.Information.visitorName = obj.visitorName;
      _this.Information.CancelCause = obj.CancelCause;          
      _this.Information.RealName = obj.RealName;
      _this.Information.AppointmentTime = obj.AppointmentTime;
      _this.Information.Phone = obj.Phone;
      _this.Information.ConsultTheme = obj.ConsultTheme;
      _this.Information.ConsultCntIntroduce = obj.ConsultCntIntroduce;
      _this.Information.ConAddressName = obj.ConAddressName;
      _this.Information.ConsultType = obj.ConsultType;
      _this.Information.CancelApproval = obj.CancelApproval;
      _this.Information.ConsultationTime = obj.ConsultationTime;
      _this.Information.CancelTime = obj.CancelTime;
      _this.Information.CancelUser = obj.CancelUser;
      _this.Information.AuditName = obj.AuditName;
      _this.Information.CancelPostil = obj.CancelPostil;
      _this.CancelSchedul = obj.CancelSchedul.toString();
    },
    UpdateStatus(CancelApproval, AppointmentID) {
      let CancelPostil = '';
      if (CancelApproval == 3) {
        CancelPostil = this.Information.CancelPostil;
      }
      this.UpdateStatusload = true;
      this.$Http_Post('ConsultSubscribe/CancelReservation', {AppointmentID: AppointmentID,CancelApproval: CancelApproval,CancelPostil: CancelPostil,CancelCause:this.Information.CancelCause,CancelSchedul:this.CancelSchedul}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.dialogTableVisible = false;
          this.GetData();
          // this.$parent.RefreshAppointmentCount(-1);
        } else {
          this.Global.request_failure(res.Message);
          this.dialogTableVisible = false;
        }
        this.UpdateStatusload = false;
      })
    },
  },
}
</script>
<style>
.el-tabs {
  height: 100%;
}
.list-cnt {
  height: 100%;
}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
.td_left{width: 80px;}
</style>
